import { ErrorReason, ErrorStatus } from '@tink/core/src/tinkLinkErrorCodes';

export const POLL_TIMEOUT = 60 * 1000;

export const POLL_INTERVAL = 1000;

export const POLL_DELAY = 100;

export const BANK_LOADING_OVERLAY_DELAY = 3000;

export const credentialsTimeoutError = {
  errorStatus: ErrorStatus.INTERNAL_ERROR,
  errorReason: ErrorReason.REQUEST_TIMEOUT_GET_CREDENTIALS,
};
